"use client";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function GlobalBackgroundAnimations() {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" />;

    return (
        <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
            {/* 
                We use a large SVG that covers the viewport. 
                Elements are positioned relatively within this 100x100 coordinate space or using absolute divs.
                Using absolute divs with distinct SVGs allows easier individual positioning/sizing.
            */}

            {/* Shape 1: Large Squiggle (Top Left) */}
            <motion.div
                className="absolute top-[10%] left-[5%] w-64 h-64 opacity-40 text-accent-blue"
                animate={{
                    y: [0, -20, 0],
                    rotate: [0, 5, 0],
                }}
                transition={{
                    duration: 8,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            >
                <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
                    <path
                        d="M0,50 Q25,25 50,50 T100,50"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        style={{
                            strokeDasharray: "100",
                            animation: "draw 10s linear infinite alternate",
                        }}
                    />
                </svg>
            </motion.div>

            {/* Shape 2: Circle (Middle Right) */}
            <motion.div
                className="absolute top-[40%] right-[10%] w-48 h-48 opacity-30 text-ink"
                animate={{
                    y: [0, 30, 0],
                    scale: [1, 1.1, 1],
                }}
                transition={{
                    duration: 12,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            >
                <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
                    <circle
                        cx="50"
                        cy="50"
                        r="40"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        style={{
                            strokeDasharray: "251", // 2 * pi * 40
                            animation: "draw 15s linear infinite",
                        }}
                    />
                </svg>
            </motion.div>

            {/* Shape 3: Triangle/Zigzag (Bottom Left) */}
            <motion.div
                className="absolute bottom-[20%] left-[15%] w-56 h-56 opacity-30 text-accent-blue-light"
                animate={{
                    y: [0, -15, 0],
                    x: [0, 10, 0],
                }}
                transition={{
                    duration: 10,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            >
                <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
                    <path
                        d="M10,90 L50,10 L90,90"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{
                            strokeDasharray: "240",
                            animation: "draw 12s linear infinite reverse",
                        }}
                    />
                </svg>
            </motion.div>

            {/* Shape 4: Cross (Top Right - offset) */}
            <motion.div
                className="absolute top-[20%] right-[25%] w-32 h-32 opacity-20 text-ink"
                animate={{
                    rotate: [0, 90, 180, 270, 360],
                }}
                transition={{
                    duration: 25,
                    repeat: Infinity,
                    ease: "linear",
                }}
            >
                <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
                    <path
                        d="M50,10 L50,90 M10,50 L90,50"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        style={{
                            strokeDasharray: "80",
                            animation: "draw 8s linear infinite alternate-reverse",
                        }}
                    />
                </svg>
            </motion.div>
            {/* Shape 5: Long Wave (Bottom Right) */}
            <motion.div
                className="absolute bottom-[10%] right-[5%] w-96 h-32 opacity-40 text-accent-blue"
                animate={{
                    x: [0, -20, 0],
                }}
                transition={{
                    duration: 15,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            >
                <svg viewBox="0 0 200 100" className="w-full h-full overflow-visible">
                    <path
                        d="M0,50 C50,20 50,80 100,50 S150,80 200,50"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        style={{
                            strokeDasharray: "250",
                            animation: "draw 18s linear infinite",
                        }}
                    />
                </svg>
            </motion.div>
        </div>
    );
}
